import { render, staticRenderFns } from "./SupplierQuotesForm.vue?vue&type=template&id=f16689c8&"
import script from "./SupplierQuotesForm.vue?vue&type=script&lang=js&"
export * from "./SupplierQuotesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports